// 썸네일/이미지가 "없음"인지 판별하는 공용 기준.
// 목록 표시(Thumbnail)와 수정 폼(NoticeForm)이 같은 기준을 쓰도록 한곳에 둔다.
//
// default-notice 패턴: 과거 프론트가 썸네일 미업로드 공지에 박아 넣던 기본
// 이미지 URL(https://.../default-notice.png). 실제 파일은 없어(404) "이미지 없음"으로 본다.
const DEFAULT_IMAGE_PATTERN = /default-notice/i;

export const isEmptyImageSrc = (src) => {
  if (typeof src !== "string" || src.trim() === "") return true;
  return DEFAULT_IMAGE_PATTERN.test(src);
};
